import { StringUtils } from "../../../../Global/Base/Utils/StringUtils";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";

export class Avatar extends HTMLElement {
    //#region Fields
    private _avatarName: string = "";
    private _backgroundColor: string = "";

    public set avatarName(name: string) {
        this._avatarName = name;
        this._createInitials();
    }

    public get backgroundColor(): string {
        return this._backgroundColor;
    }

    public set backgroundColor(color: string) {
        this._backgroundColor = color;
        this.setAttribute("data-color", color);
    }

    //#endregion Fields

    //#region Constructors
    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        // volat funkci na vytvoření iniciál ze jména
        this.classList.add("avatar");
    }

    //#endregion Constructors

    //#region Methods

    // vytvoří z jména Iniciály
    private _createInitials(): void {
        this.title = this._avatarName;
        const nameField = StringUtils.isNullOrEmpty(this._avatarName) ? "" : this._avatarName.split(" ", 2);
        for (const entry of nameField) {
            this.innerText += entry.charAt(0);
        }
    }
    //#endregion Methods
}

registerCustomElement("tsc-avatar", Avatar);
